import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { updateCart } from "../../../v1/actions/user"

import FirstLevelCategories from "./FirstLevelCategories"

const ServicesCategoryIndex = (props) => {
  const categorySelect = () => {
    props.handleChangeCategory()
  }

  return (
    <>
      <FirstLevelCategories categorySelect={categorySelect} />
    </>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let isCart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
    isCart = false
  } else {
    isCart = true

    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    isCart: isCart,
    cart: cart,
    user: user,
    activeVehicle
  }
}

export default connect(mapStateToProps, { updateCart })(ServicesCategoryIndex)
